import Card from '@/api/card'

export default {
  namespaced: true,
  actions: {
    create: (store, { number, month, year, cvx }) => Card.create(number, month, year, cvx)
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/cards/index.js